export default {
  error_messages: {
    failed_to_fetch_orders:
      'Error al cargar los datos. Haz clic en el icono de «actualizar» o inténtalo de nuevo en 1 minuto.',
    something_went_wrong: 'Algo salió mal, inténtalo de nuevo.',
  },
};
